import { getTenant } from './index'

export const addTenantOnLink = (url) => {
  if (url && !url.includes(getTenant())) {
    url = `/${getTenant()}/` + url
  }
  return url
}

export const removeTenantOnLink = (url) => {
  return url.replace(`/${getTenant()}/`, '')
}
